<template>
  <div>
    <svg @click="toggleClick" class="hamburger" :class="{ 'is-active': isActive }" viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg" width="24" height="24">
      <path
        d="M966.8 568.8H57.2c-31.4 0-56.9-25.5-56.9-56.9s25.5-56.9 56.9-56.9h909.6c31.4 0 56.9 25.5 56.9 56.9s-25.5 56.9-56.9 56.9zM966.8 881.5H57.2c-31.4 0-56.9-25.5-56.9-56.9s25.5-56.9 56.9-56.9h909.6c31.4 0 56.9 25.5 56.9 56.9s-25.5 56.9-56.9 56.9zM966.8 256.2H57.2c-31.4 0-56.9-25.5-56.9-56.9s25.5-56.9 56.9-56.9h909.6c31.4 0 56.9 25.5 56.9 56.9s-25.5 56.9-56.9 56.9z">
      </path>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: { type: Boolean, default: false },
    toggleClick: { type: Function, default: null }
  }
}
</script>

<style scoped>
.hamburger {
  cursor: pointer;
  fill: #333;
  transition: 0.3s;
}

.hamburger.is-active {
  transform: rotate(90deg);
}
</style>
